<template>
  <Section :content="problemsSlowingYouDown" :uniqueContent="'problemsButtons'" />
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import Section from '@/components/section.vue';
export default {
  name: 'problemsSlowingYouDown',
  components: {
    Section,
  },
  data() {
    return {
      problemsSlowingYouDown: {
        //eyebrow: 'Property Management \u0026 AECO: Architecture, Engineering, Construction \u0026 Operations',
        eyebrowIcon: '',
        headline: 'These problems slowing you down?',
        paragraphs: [],
        id: 'problems-slowing-you-down',
        image: '',
        videoId: '892755542',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        html: '',
        learnMoreLink: ''
      },
    }
  },
};
</script>
